import { render, staticRenderFns } from "./pos-product-data-collector-modal.vue?vue&type=template&id=75aef426&scoped=true&"
import script from "./pos-product-data-collector-modal.vue?vue&type=script&lang=ts&"
export * from "./pos-product-data-collector-modal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75aef426",
  null
  
)

export default component.exports